import { env } from "./env";

export const mockFlags = {
  auth: env.VITE_MOCK_AUTH,
  dashboard: env.VITE_MOCK_DASHBOARD,
  properties: env.VITE_MOCK_PROPERTIES,
  leads: env.VITE_MOCK_LEADS,
  pipeline: env.VITE_MOCK_PIPELINE,
  proposals: env.VITE_MOCK_PROPOSALS,
  deals: env.VITE_MOCK_DEALS,
  demands: env.VITE_MOCK_DEMANDS,
  agenda: env.VITE_MOCK_AGENDA,
  contracts: env.VITE_MOCK_CONTRACTS,
  inspections: env.VITE_MOCK_INSPECTIONS,
  cobroking: env.VITE_MOCK_COBROKING,
  listings: env.VITE_MOCK_LISTINGS,
  commissions: env.VITE_MOCK_COMMISSIONS,
  wallet: env.VITE_MOCK_WALLET,
  financial: env.VITE_MOCK_FINANCIAL,
  automation: env.VITE_MOCK_AUTOMATION,
  reports: env.VITE_MOCK_REPORTS,
  settings: env.VITE_MOCK_SETTINGS,
  notifications: env.VITE_MOCK_NOTIFICATIONS,
  goals: env.VITE_MOCK_GOALS,
  subscription: env.VITE_MOCK_SUBSCRIPTION,
  launches: env.VITE_MOCK_LAUNCHES,
  referrals: env.VITE_MOCK_REFERRALS,
  onboarding: env.VITE_MOCK_ONBOARDING,
  support: env.VITE_MOCK_SUPPORT,
  partners: env.VITE_MOCK_PARTNERS,
  showcases: env.VITE_MOCK_SHOWCASES,
} as const;

export type ModuleName = keyof typeof mockFlags;

export function isMockEnabled(mod: ModuleName): boolean {
  return mockFlags[mod];
}

export function listActiveMocks(): ModuleName[] {
  return (Object.keys(mockFlags) as ModuleName[]).filter((m) => mockFlags[m]);
}

export function hasAnyMock(): boolean {
  return listActiveMocks().length > 0;
}
